import { Button, Card, Link, Title, WarningGreyIcon } from 'internalLibrary';
import { FC } from 'react';
import { ORIGIN_URL } from 'config/app';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import layout from '../../../../scss/layout.module.scss';
import LoanApplicationProcessLayout from 'ui/components/LoanApplicationProcessLayout';
import style from './Cancelled.module.scss';
import useAuth from 'ui/hooks/useAuth';

const CancelledScene: FC = () => {
  const { logout } = useAuth();
  const { t } = useTranslation();

  const backToHomepageClicked = () => {
    logout();
  };

  return (
    <LoanApplicationProcessLayout>
      <Title
        icon={<WarningGreyIcon />}
        text={t('rejectedTink_title')}
        className={style.title}
        forceColumn
      />

      <div className={layout['center-content']}>
        <div className={layout['width-lg']}>
          <Card className={style.card}>
            <Card intent="success" className={style['inner-card']}>
              <span className={style['card-main-text']}>
                {t('rejectedTink_card_main')}
              </span>
            </Card>
            <div className={style['card-bottom-text']}>
              {t('rejectedTink_card_bottom')}{' '}
              <Link href={ORIGIN_URL + '/faq'}>FAQ</Link>.
            </div>
          </Card>
        </div>
      </div>

      <div className={layout['center-content']}>
        <Button
          className={classNames(style['button-actor'], style.button)}
          onClick={backToHomepageClicked}
        >
          {t('rejectedTink_button')}
        </Button>
      </div>
    </LoanApplicationProcessLayout>
  );
};

export default CancelledScene;
